module.exports = __webpack_public_path__ + "static/media/iconMarket.b9580079.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/serviceicon2/iconMarket.svg
// module id = 438
// module chunks = 0